import { yellow } from 'chalk';

export default (msg: string) => `${yellow('> NOTE:')} ${msg}`;
